import { Bold2 } from '@uswitch/spark.type'

import * as st from '../styles'

export const InfoList = ({ heading, data }) => {
  const renderData = () => {
    if (!data || data.length === 0) {
      return null
    }

    if (data.length > 0) {
      return (
        <>
          <Bold2 sx={st.tableHeading}>{heading}</Bold2>
          <ul sx={st.infoList}>
            {data.map((dataItem, idx) => (
              <li key={idx}>{dataItem}</li>
            ))}
          </ul>
        </>
      )
    }
  }
  return <div>{renderData()}</div>
}
